import { useMemo } from 'react'

import {
  useQueryGetAvailableMigrations,
  useQueryGetInstalledMigrations
} from '../services/migrations.service'

import { InstalledMigrationsColumns } from '@/modules/migrations/columns'

export const useInstalledMigrationsTable = (organizationId?: string) => {
  const orgId = organizationId || ''

  const installedMigrationsQuery = useQueryGetInstalledMigrations(orgId)

  const availableMigrationsQuery = useQueryGetAvailableMigrations(orgId)

  const rowData = useMemo(() => {
    if (!installedMigrationsQuery.data) {
      return []
    }

    return installedMigrationsQuery.data.map((installedMigration) => {
      const availableMigration = availableMigrationsQuery.data?.find(
        (blueprint) => blueprint.id === installedMigration.blueprint_id
      )

      return {
        ...installedMigration,
        blueprint_slug: availableMigration?.slug,
        blueprint_name: availableMigration?.name,
        blueprint_description: availableMigration?.description
      }
    })
  }, [installedMigrationsQuery.data, availableMigrationsQuery.data])

  return {
    data: rowData,
    isLoading: installedMigrationsQuery.isLoading,
    columns: InstalledMigrationsColumns
  }
}
